// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerLongLeft_container__0Rd_u","content":"ContainerLongLeft_content__LM1B4"};